/**
 * @generated SignedSource<<4d5af0a5ee12a1092180a04598672956>>
 * @relayHash 4e5e1132ecf68f19dafb0d3318a35af2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 031139a7296ea89a2df083fa7c188b8f87a1d1feafce3bd3d16b59156b6ce4ee

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkItemEntrypointUiQuery } from './WorkItemEntrypointUiQuery.graphql';

import shouldShowHumanSupervisor_provider from '@atlassian/jira-relay-provider/src/jira-ai-show-human-supervisor-avatar.relayprovider';
import fixDisabledVotingOption_provider from '@atlassian/jira-relay-provider/src/jracloud-81233-fix-disabled-voting-option.relayprovider';
import isIssueViewFieldConfigEditEnabled_provider from '@atlassian/jira-relay-provider/src/relay-migration-issue-fields-custom-field-config.relayprovider';

const node: PreloadableConcreteRequest<WorkItemEntrypointUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "031139a7296ea89a2df083fa7c188b8f87a1d1feafce3bd3d16b59156b6ce4ee",
    "metadata": {},
    "name": "WorkItemEntrypointUiQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingoptionrelayprovider": fixDisabledVotingOption_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": isIssueViewFieldConfigEditEnabled_provider
    }
  }
};

export default node;
